import React, { useCallback, useMemo } from 'react';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import { FIELD_TYPES } from '../../constants';
import { getCheckboxGroupError } from '../../fields/checkbox-group/checkbox-group-utils';
import { useFieldValidation } from '../../contexts/field-validation-context';
import { classes } from './checkbox-group.st.css';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { Checkbox as TPACheckbox, CheckboxGroup as TPACheckboxGroup } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { FieldLabel } from '../field-label/field-label';
import styles from './checkbox-group.scss';
import { OtherOption } from './other-option';
import FieldDescription from '../field-description';
export const CheckboxGroupComponent = _ref => {
  let {
    path,
    label,
    hideLabel = false,
    options,
    addOther,
    addOtherLabel,
    addOtherPlaceholder,
    required = false,
    value = null,
    onChange,
    error,
    customErrors,
    disabled = false,
    description,
    validation,
    fieldType = FIELD_TYPES.CHECKBOX_GROUP,
    otherInputCharacterLimit
  } = _ref;
  const _error = getCheckboxGroupError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, fieldType);
  const {
    validateFields
  } = useFieldValidation();
  const _value = useMemo(() => value || [], [value]);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const _onChange = useCallback(newValue => {
    onChange == null || onChange(newValue);
    validateFields({
      path,
      value: newValue
    });
  }, [path, onChange, validateFields]);
  const handleChange = useCallback((optionName, isChecked) => {
    const newValue = isChecked ? [..._value, optionName] : _value.filter(val => val !== optionName);
    _onChange(newValue);
  }, [_value, _onChange]);
  return /*#__PURE__*/React.createElement(FieldDescription, {
    description: description
  }, /*#__PURE__*/React.createElement(TPACheckboxGroup, {
    newErrorMessage: true,
    error: hasError,
    errorText: errorMessage,
    className: classNames(classes.checkboxGroup, {
      [FIELD_ERROR_CLASS]: hasError
    }),
    label: /*#__PURE__*/React.createElement(FieldLabel, {
      required: required,
      label: label,
      hideLabel: hideLabel
    }),
    disabled: disabled,
    fluid: true
  }, options == null ? void 0 : options.map(_ref2 => {
    let {
      label: optionLabel
    } = _ref2;
    const isChecked = _value.includes(optionLabel);
    return /*#__PURE__*/React.createElement(TPACheckbox, {
      key: "checkbox-" + optionLabel,
      "data-hook": "checkbox-" + optionLabel,
      checked: isChecked,
      onChange: event => {
        handleChange(optionLabel, event.checked);
      },
      name: label,
      label: optionLabel,
      className: classNames(classes.checkbox, styles.checkbox, {
        [styles.checkboxError]: hasError,
        [classes.hover]: forcedHover
      })
    });
  }), /*#__PURE__*/React.createElement(OtherOption, {
    label: label,
    options: options,
    addOther: addOther,
    addOtherLabel: addOtherLabel,
    addOtherPlaceholder: addOtherPlaceholder,
    value: value,
    onChange: _onChange,
    disabled: disabled,
    hasError: hasError,
    maxLength: otherInputCharacterLimit
  })));
};
//# sourceMappingURL=checkbox-group.js.map